import React, { Component } from 'react'
import { RouteComponentProps } from 'react-router-dom'
import { WithTranslation } from 'react-i18next'

import { Mutation, Query } from 'react-apollo'
import {
  CALCULATION_QUERY,
  RANK_POSITION_MUTATION,
  DELETE_POSITION_MUTATION,
  COPY_POSITIONS_MUTATION,
} from './'

import isNil from 'lodash/isNil'
import get from 'lodash/get'

import PageLayout from 'components/layout/pageLayout'
import Head from 'components/layout/head'
import Button from 'components/ui/button'
import SelectTable, { IDuplicate, ISelectItem } from 'components/layout/selectTable'

import tableConfig from './calculationsTable.config'

interface CalculationOverviewProps extends RouteComponentProps<any>, WithTranslation {
  authenticated: boolean
  dispatch: any
}

type CalculationOverviewState = {}

class CalculationOverview extends Component<CalculationOverviewProps, CalculationOverviewState> {
  constructor(props: CalculationOverviewProps) {
    super(props)
    this.state = {}
  }

  transformCalculations = (calculations: any) => {
    if (isNil(calculations)) return null

    return calculations.map((calculation: any) => {
      Object.keys(calculation).map((key: string) => {
        if (!isNil(calculation[key]) && !calculation[key].hasOwnProperty('value')) {
          switch (key) {
            case 'amount':
              calculation[key] = { value: calculation[key], unit: calculation.unit }
              break
          }
        }
        return null
      })
      return calculation
    })
  }

  render() {
    const { t, history } = this.props

    return (
      <Query query={CALCULATION_QUERY} fetchPolicy="network-only" notifyOnNetworkStatusChange>
        {({ loading, data }: any | null) => {
          const projectNumber = get(data, 'getCalculationProject.projectNumber', undefined)
          const calculations = get(data, 'getCalculationProject.positions', undefined)

          return (
            <Mutation mutation={RANK_POSITION_MUTATION}>
              {(
                rankPosition: (payload: {
                  variables: {
                    version: string
                    projectNumber: string
                    newPosition: number
                    oldPosition: number
                  }
                }) => void,
              ) => (
                <Mutation
                  mutation={COPY_POSITIONS_MUTATION}
                  refetchQueries={() => [{ query: CALCULATION_QUERY }]}
                >
                  {(
                    copyPositions: (payload: {
                      variables: {
                        toVersion: string
                        toProjectNumber: string
                        fromPositionIds: number[]
                        fromVersions: string[]
                        from_projectNumber: string
                      }
                    }) => void,
                  ) => (
                    <Mutation mutation={DELETE_POSITION_MUTATION}>
                      {(
                        deletePosition: (payload: {
                          variables: { version: string; positionId: number; projectId: string }
                        }) => void,
                      ) => (
                        <PageLayout pageTitle={t('calculations')}>
                          <Head
                            headline={t('overviewOfYourCalculations')}
                            subheadline={
                              process.env.REACT_APP_ENV === 'rigips'
                                ? t('appNameRigips')
                                : t('appNameAbk')
                            }
                            actions={
                              <Button
                                primary
                                onClick={() => history.push('/calculations/new-calculation')}
                              >
                                {t('newCalculation')}
                              </Button>
                            }
                          />
                          <div className="mb-65">
                            <SelectTable
                              config={tableConfig(t)}
                              isLoading={loading}
                              onOrderChange={(
                                source: number,
                                destination: number,
                                item: ISelectItem,
                              ) => {
                                rankPosition({
                                  variables: {
                                    version: String(item.version),
                                    projectNumber,
                                    newPosition: destination,
                                    oldPosition: source,
                                  },
                                })
                              }}
                              onDelete={(items: ISelectItem[]) => {
                                items.map((item) => {
                                  deletePosition({
                                    variables: {
                                      version: String(item.version),
                                      positionId: Number(item.positionId),
                                      projectId: projectNumber,
                                    },
                                  })
                                  return item
                                })
                              }}
                              onDuplicate={(duplicates) => {
                                const versions: string[] = duplicates.map((duplicate: IDuplicate) =>
                                  String(duplicate.version),
                                )

                                copyPositions({
                                  variables: {
                                    fromVersions: versions,
                                    toVersion: '',
                                    from_projectNumber: projectNumber,
                                    toProjectNumber: projectNumber,
                                    fromPositionIds: [Number(duplicates[0].positionId)],
                                  },
                                })
                              }}
                              data={this.transformCalculations(calculations)}
                            />
                          </div>
                        </PageLayout>
                      )}
                    </Mutation>
                  )}
                </Mutation>
              )}
            </Mutation>
          )
        }}
      </Query>
    )
  }
}

export default CalculationOverview
